import * as React from 'react';

import { Panel } from '@ixicare/ui';
import { t } from '~i18n';
import SiteSettingsFormContainer from '../containers/SiteForm';

const SiteCreatePage = () => (
  <Panel>
    <Panel.Title>{t('site.form.create')}</Panel.Title>
    <SiteSettingsFormContainer />
  </Panel>
);

export default SiteCreatePage;
